/**
 * Values shared across the nav module, collected here so they can be changed
 * in one place rather than hunted for in the component that happens to use
 * them first.
 */

/**
 * `localStorage` key holding the user's sidebar pin preference.
 *
 * Deliberately identical to the key Backstage's `SidebarPage` used, so users
 * keep whatever pin state they already had when this layout replaced it.
 * Changing it silently resets everyone's preference.
 */
export const PIN_STATE_STORAGE_KEY = "sidebarPinState";

/**
 * Id of the content region, targeted by the skip link.
 *
 * Deliberately not a `<main>`. Pages supply their own via `core-components`'
 * `Page`, which renders `<main data-backstage-core-page>`; making this wrapper
 * one too would nest a second `main` inside it, which is invalid and gives
 * assistive technology two competing main landmarks.
 */
export const CONTENT_ELEMENT_ID = "app-content";

/**
 * Icon size for top-level rail items. Slightly larger than the repo's default
 * of 16 because these are the primary affordance in a 72px collapsed rail.
 */
export const NAV_ICON_SIZE = 20;

/** Icon size for submenu rows, matching the repo default. */
export const SUBMENU_ICON_SIZE = 16;
